import "./App.css";
import Homepage from "./Pages/Homepage";
import { Redirect, Route, Switch } from "react-router-dom";
import Chatpage from "./Pages/Chatpage";
import { Box, Button, Text } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

const isAuthenticated = () => {
  try {
    return !!JSON.parse(localStorage.getItem("userInfo"));
  } catch {
    return false;
  }
};

// Auth guard: unauthenticated visits to /chats bounce back to /.
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? <Component {...props} /> : <Redirect to="/" />
    }
  />
);

const NotFound = () => {
  const history = useHistory();
  return (
    <Box textAlign="center" py={20} px={6}>
      <Text fontSize="6xl" fontWeight="bold">
        404
      </Text>
      <Text fontSize="xl" mt={2}>
        Page not found
      </Text>
      <Button mt={6} colorScheme="blue" onClick={() => history.push("/")}>
        Go Home
      </Button>
    </Box>
  );
};

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/" component={Homepage} exact />
        <PrivateRoute path="/chats" component={Chatpage} />
        <Route component={NotFound} />
      </Switch>
    </div>
  );
}

export default App;
